import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _AddAccountToDashBoard, _AddKpi, _DashBoard, _Kpi } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectProccessTypeConstants } from "../../../erp/cellEditor/CashRequest/FactoryDocument/SelectProccessTypeConstants";
import { BasicButton } from "../../../theme/Component/BasicButton";
import usePaginator from "../../../theme/Component/usePaginator";
import { KpiEditor } from "../Kpi/KpiEditor";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";
import { AccountEditor } from "../../../editor/AccountEditor";
import { KpiByDashBoard } from "./KpiByDashBoard";
import { DashBoardAccountCatalog } from "./DashBoardAccountCatalog";


export const KpiDashBoardByAcc = () => {

    const DashBoard = useDataBean(_DashBoard);
    const addkpi = useDataBean(_AddKpi);
    const addAccount = useDataBean(_AddAccountToDashBoard);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [processType, setprocessType] = useState<number>(null)
    const [modalagregar, setModalagregar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modallist, setModallist] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modallistuser, setModallistuser] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [regexStr, setregexStr] = useState<any>(null)
    const [form, setForm] = useState<any>({
        Account: _single.getAccountID()
    })
    const paginador = usePaginator();
    const modalkpi = useModal("KPI", MODAL_LG);
    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        DashBoard.instance.getDashBoardCatalog(processType, null, regexStr, form.Account, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        DashBoard.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        DashBoard.instance.deleteDashBoard(DashBoard.bean.IDDashBoard).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {

        DashBoard.instance.updateDashBoard(DashBoard.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addKpiToDashBoard = () => {

        addkpi.instance.addKpiToDashBoard(DashBoard.bean.IDDashBoard, addkpi.bean.IDKpi).then(
            (resp: any) => {

                toast.success('Kpi Agregada');
                modalkpi.close();
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addAccountToDashBoard = () => {

        addAccount.instance.addAccountToDashBoard(DashBoard.bean.IDDashBoard, addAccount.bean.IDAccount).then(
            (resp: any) => {

                toast.success('Usuario Agregado');
                setModalagregar({ ...modalagregar, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDDashBoard', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha Creacion', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Agregar KPI', icono: 'ri-add-circle-fill', visible: single.canDelete(), evento: () => { modalkpi.open() } },
            { titulo: 'Agregar Usuario', icono: 'ri-user-add-line', visible: single.canDelete(), evento: () => { setModalagregar({ ...modalagregar, "view": true }) } },
            { titulo: 'Lista de Indicadores KPI', icono: 'ri-mist-fill', visible: single.canDelete(), evento: () => { setModallist({ ...modallist, "view": true }) } },
            { titulo: 'Lista de Usuarios', icono: 'ri-user-follow-line', visible: single.canDelete(), evento: () => { setModallistuser({ ...modallistuser, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Mis Tableros de Control">
            <div className="row">
                <div className="col-md-6">
                    <SelectProccessTypeConstants idSelector={processType} onChange={(e) => { setprocessType(e) }} />
                </div>
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6">
                    <AccountEditor disabled={true} idAccount={form.Account} onChange={(e: any) => { setForm({ ...form, "Account": e.IDAccount }) }} label="Usuario de Tablero de Control" />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Consultar
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={DashBoard.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <SelectProccessTypeConstants idSelector={DashBoard.bean.ProcessType} onChange={(e) => { DashBoard.setBean({ ...DashBoard.bean, "ProcessType": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={DashBoard.bean.Name} onChange={DashBoard.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={DashBoard.bean.Description} onChange={DashBoard.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalagregar} updateModal={setModalagregar} eventModal={addAccountToDashBoard}>
                        <div className="row">
                            <AccountEditor idAccount={addAccount.bean.IDAccount} label="Contacto" onChange={(e) => { addAccount.setBean({ ...addAccount.bean, "IDAccount": e.IDAccount }) }} />
                        </div>
                    </Modal>
                    <Modal modal={modallist} updateModal={setModallist}>
                        <div className="row">
                            <KpiByDashBoard idDashBoard={DashBoard.bean.IDDashBoard} />
                        </div>
                    </Modal>
                    <Modal modal={modallistuser} updateModal={setModallistuser}>
                        <div className="row">
                            <DashBoardAccountCatalog idDashBoard={DashBoard.bean.IDDashBoard} />
                        </div>
                    </Modal>
                    <Modal modal={modalkpi.modal} updateModal={modalkpi.setModal} eventModal={addKpiToDashBoard}>
                        <KpiEditor render={addkpi.bean.Name} idSelector={addkpi.bean.IDKpi} onChange={(e) => { addkpi.setBean({ ...addkpi.bean, "IDKpi": e.IDKpi, "Name": e.Name }) }} returnType="Object" />
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {DashBoard.bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}